import { render, staticRenderFns } from "./WarehouseManagement.vue?vue&type=template&id=d98c635a&scoped=true&"
import script from "./WarehouseManagement.vue?vue&type=script&lang=js&"
export * from "./WarehouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseManagement.vue?vue&type=style&index=0&id=d98c635a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98c635a",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QCard,QCardSection,QTabs,QTab,QSeparator,QTabPanels,QTabPanel})
